// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import iview from 'iview';
import App from './App.vue'
import "babel-polyfill";
import '../../../my-theme/index.less';
import util from '@commonjs/util.js';

Vue.config.productionTip = false;

Vue.use(iview);

Vue.prototype.ajax = util.JAjax;
Vue.prototype.aUrl = util.url;

new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
});

